// Adapter: maps a Payroll Manpower contractor record into the workman-shaped
// object expected by `printScreeningForm` / `printIdentityCard` /
// `printIdentityCardsBulk`. Reuses the existing workmen printables verbatim.

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function photoUrl(photo) {
  if (!photo) return null;
  if (typeof photo === "string") return photo; // already a URL or data URL
  if (photo.path) return `${API}/files/${photo.path}`;
  return null;
}

export function contractorToWorkman(c) {
  if (!c) return null;
  // Designation comes from the first trade (Payroll Manpower form uses trades[0]).
  const designation = (c.trades && c.trades[0]) || c.contractor_type || "";
  return {
    id: c.id,
    name: c.name || "",
    trade: designation,
    mobile: c.contact_phone || "",
    gender: c.gender || "",
    date_of_birth: c.date_of_birth || "",
    age_years: c.age_years,
    blood_group: c.blood_group || "",
    aadhaar: c.id_proof_type === "Aadhar" ? c.id_proof_number : (c.aadhaar || ""),
    id_proof_type: c.id_proof_type === "Aadhar" ? "Aadhaar" : c.id_proof_type,
    id_proof_number: c.id_proof_number,
    pincode: c.pincode || "",
    village: c.village || "",
    city: c.city || "",
    state: c.state || "",
    address: c.address || "",
    marital_status: c.marital_status || "",
    children_count: c.children_count,
    mother_tongue: c.mother_tongue || "",
    other_languages: c.other_languages || "",
    emergency_contact_name: c.emergency_contact_name || "",
    emergency_contact_number: c.emergency_contact_number || "",
    vision: c.vision || "",
    height: c.height || "",
    weight: c.weight || "",
    hearing: c.hearing || "",
    physical_deformities: c.physical_deformities || "",
    medical_history: c.medical_history || "",
    experience_years:
      typeof c.experience_years === "number"
        ? c.experience_years
        : (Number(c.experience_india_years || 0) + Number(c.experience_abroad_years || 0)),
    ncc_site_name: c.ncc_site_name || "",
    is_payroll: !!c.is_payroll,
    source: c.source || "",
    source_agency_name: c.source_agency_name || "",
    // ID Card metadata
    id_card_no: c.id_card_no || "",
    id_card_issued_at: c.id_card_issued_at || "",
    // Convert photo FileRef → absolute URL so the print popup can load it.
    photo_base64: photoUrl(c.photo),
  };
}
